export default __webpack_public_path__ + "static/commitment-e450a0a45863345f28175aa5935c0abe.gif";